import AbstractWidgetNotificationsCollection from './YPAbstractWidgetNotificationsCollection';
import RosterNotification from './YPRosterNotificationObject';

export default class RosterNotifications extends AbstractWidgetNotificationsCollection {
  constructor(notifications) {
    super(notifications, 'rosterPublishedUntil', (notification) =>
      notification.notificationMessages.map(
        (notificationMessage) =>
          new RosterNotification(
            notification.id,
            notification.timestamp,
            notification.isRead,
            notificationMessage
          )
      )
    );
    this.deltaRosterNotifications = []; // Necessary for RosterContainer
  }
}
